import {
  Account,
  Person,
  isValidAccount,
  isValidPerson,
} from '../schema/accountSchema'
export interface ValidationResult {
  passed: boolean
  accountCount: number
  totalPeople: number
  clientContactsCount: number
  quadTeamCount: number
  errors: string[]
  warnings: string[]
  autoFixes: string[]
}
export function validateSeedData(accounts: Account[]): ValidationResult {
  const result: ValidationResult = {
    passed: true,
    accountCount: accounts.length,
    totalPeople: 0,
    clientContactsCount: 0,
    quadTeamCount: 0,
    errors: [],
    warnings: [],
    autoFixes: [],
  }
  // Check account count
  if (accounts.length < 100) {
    result.errors.push(
      `Expected at least 100 accounts, found ${accounts.length}`,
    )
    result.passed = false
  }
  // Check each account
  accounts.forEach((account, index) => {
    // Validate account structure
    if (!isValidAccount(account)) {
      result.errors.push(`Account at index ${index} has invalid structure`)
      result.passed = false
      return
    }
    // Check people data
    const clientContacts = account.client_contacts || []
    const quadTeam = account.quad_team || []
    if (clientContacts.length < 7) {
      result.warnings.push(
        `${account.name}: Expected 7 client contacts, found ${clientContacts.length}`,
      )
    }
    if (quadTeam.length < 5) {
      result.warnings.push(
        `${account.name}: Expected 5 Quad team members, found ${quadTeam.length}`,
      )
    }
    // Validate people
    const allPeople = [...clientContacts, ...quadTeam]
    allPeople.forEach((person) => {
      if (!isValidPerson(person)) {
        result.errors.push(
          `${account.name}: Invalid person data for ${person.name || 'unknown'}`,
        )
        result.passed = false
      }
      // Check email domain matches side
      if (person.side === 'Quad' && !person.email.includes('@quad')) {
        result.warnings.push(
          `${account.name}: Quad member ${person.name} has non-Quad email`,
        )
      }
    })
    result.totalPeople += allPeople.length
    result.clientContactsCount += clientContacts.length
    result.quadTeamCount += quadTeam.length
    // Check orders
    if (!account.kpis || typeof account.kpis.active_jobs !== 'number') {
      result.errors.push(`${account.name}: Missing or invalid KPIs`)
      result.passed = false
    }
  })
  // Check for duplicate account names
  const names = new Set<string>()
  accounts.forEach((account) => {
    if (names.has(account.name)) {
      result.errors.push(`Duplicate account name: ${account.name}`)
      result.passed = false
    }
    names.add(account.name)
  })
  return result
}
export function printValidationReport(result: ValidationResult): void {
  console.log('\n=== QUAD ATLAS DATA VALIDATION REPORT ===\n')
  console.log(`✓ Accounts: ${result.accountCount}`)
  console.log(`✓ Total People: ${result.totalPeople}`)
  console.log(`✓ Client Contacts: ${result.clientContactsCount}`)
  console.log(`✓ Quad Team: ${result.quadTeamCount}`)
  if (result.errors.length > 0) {
    console.log('\n❌ ERRORS:')
    result.errors.forEach((error) => console.log(`  - ${error}`))
  }
  if (result.warnings.length > 0) {
    console.log('\n⚠️  WARNINGS:')
    result.warnings.forEach((warning) => console.log(`  - ${warning}`))
  }
  if (result.autoFixes.length > 0) {
    console.log('\n🔧 AUTO-FIXES APPLIED:')
    result.autoFixes.forEach((fix) => console.log(`  - ${fix}`))
  }
  console.log(
    `\n${result.passed ? '✅ VALIDATION PASSED' : '❌ VALIDATION FAILED'}\n`,
  )
}
